<lsq-button
    class="requestDocumentBtn"
    [appearance]="'primary'"
    [size]="'sm'"
    (buttonClick)="handleRequestDocument()"
>
    {{ label }}
</lsq-button>
